package org.example.loadingkdz.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import io.ktor.client.*
import io.ktor.client.request.*
import kotlinx.coroutines.*
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.example.loadingkdz.styles.InputStyle
import org.example.loadingkdz.styles.MainButtonStyle
import com.varabyte.kobweb.silk.components.style.toModifier
import io.ktor.client.statement.*
import io.ktor.http.*
import org.example.loadingkdz.models.Theme
import org.example.loadingkdz.styles.GroupStyle
import com.varabyte.kobweb.silk.components.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.attributes.*
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap

//val urlConnect = "https://kdz.novogran.ua:8888/KDZ/hs/LoadingKDZ"
val urlConnect = "https://kdz-clients.msht.eu:8989/kdz-clients/hs/LoadingKDZ"

@Page
@Composable
fun HomePage() {

    var buyerAuthorized by remember { mutableStateOf(false)}
    var buyerCode by remember { mutableStateOf("")}
    var buyerName by remember { mutableStateOf("")}

    Box(
        modifier = Modifier
            .fillMaxSize(),
        contentAlignment = Alignment.TopStart
    ) {

        MainBackground()

        if (!buyerAuthorized)
            //Авторизація
            Column(modifier = Modifier
                .fillMaxSize(),
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.Center){
                Column(modifier = GroupStyle.toModifier(),
                    horizontalAlignment = Alignment.CenterHorizontally) {
                    Row (verticalAlignment = Alignment.CenterVertically) {
                        P(
                            attrs = Modifier
                                .margin(top = 13.px, left = 5.px)
                                .height(35.px)
                                .fontWeight(FontWeight.Bold)
                                .color(Theme.Secondary.rgb)
                                .align(Alignment.CenterHorizontally)
                                .toAttrs()
                        ) {
                            Text(value = "Код доступу:")
                        }

                        Input(type = InputType.Text,
                            attrs = InputStyle.toModifier()
                                .padding(6.px)
                                .margin(5.px)
                                .fontSize(14.px)
                                .width(100.px)
                                .height(30.px)
                                .boxShadow(0.px, 0.px, 0.px, 0.px, null)
                                .toAttrs {
                                    onInput {
                                        buyerCode = it.value
                                    }
                                    value(buyerCode)
                                }
                        )

                        Button(
                            modifier = MainButtonStyle.toModifier()
                                .fontSize(12.px)
                                .margin(5.px)
                                .height(35.px)
                                .backgroundColor(Theme.Primary.rgb)
                                .width(60.px),

                            onClick = {
                                val client = HttpClient()
                                CoroutineScope(Dispatchers.Main).launch {
                                    try {
                                        val response = withContext(Dispatchers.Default) {
                                            client.get("$urlConnect/auth?secret=$buyerCode"){
                                                headers {
                                                    //append(HttpHeaders.Authorization, "Basic bW9kdWxzb2Z0OnRyeTY1NA==")
                                                }
                                            }
                                        }
                                        when (response.status.value) {
                                            200 -> {buyerName = response.bodyAsText()
                                                buyerAuthorized = true}
                                            401 -> buyerName = response.bodyAsText()
                                            else -> buyerName = "Не вдалось авторизуватись"
                                        }

                                    } catch (e: Exception) {
                                        buyerName = "Не вдалось авторизуватись"
                                    }
                                }
                            }
                        ) { Text("Вхід") }

                    }

                    if (buyerName!=="")
                        P(
                        attrs = Modifier
                            .fontSize(14.px)
                            .height(35.px)
                            .color(Theme.Secondary.rgb)
                            .toAttrs(
                            ))
                        {
                            Text(value = buyerName)
                        }
                }
            }
        else
            Column(modifier = Modifier.fillMaxSize(),
                horizontalAlignment = Alignment.CenterHorizontally){
                //headerPage(buyerName)
                order(buyerCode)
            }
    }
}

@Composable
fun MainBackground() {
    Image(
        modifier = Modifier
            .fillMaxSize()
            .objectFit(ObjectFit.Cover),
        src = "background.png",
        desc = "Background Image"
    )
}

@Composable
fun headerPage(buyer:String) {

    Row (modifier = Modifier.fillMaxWidth()) {
        Image(src = "logo.png", desc = "Logo")

        Column(modifier = Modifier.fillMaxWidth().backgroundColor(Theme.Primary.rgb),
            horizontalAlignment = Alignment.End){

            Row (){
                P(attrs = Modifier
                    .margin(top = 10.px, left = 5.px)
                    .fontSize(14.px)
                    .height(20.px)
                    .width(150.px)
                    .toAttrs()){
                    Text("Пн.-Пт.: 9:00-17:00")
                }

                P(attrs = Modifier
                    .margin(top = 10.px, left = 5.px)
                    .fontSize(14.px)
                    .height(20.px)
                    .width(150.px)
                    .toAttrs()){
                    Text("+38 067 411 21 68")
                }
            }

            Row (){
                P(attrs = Modifier
                    .margin(top = 10.px, left = 5.px)
                    .fontSize(14.px)
                    .height(20.px)
                    .width(150.px)
                    .toAttrs()){
                    Text("м. Новоград-Волинський")
                }

                P(attrs = Modifier
                    .margin(top = 10.px, left = 5.px)
                    .fontSize(14.px)
                    .height(20.px)
                    .width(150.px)
                    .toAttrs()){
                    Text("вул. Гранітна, 24.")
                }
            }
        }
    }
}

@Composable
fun order(buyerCode:String) {

    val breakpoint by rememberBreakpoint()
    val regex = Regex("[^A-Za-zА-Яа-я0-9.,'():ІіЄєЇїь -]")
    var getDate by remember { mutableStateOf(false) }
    var products by remember { mutableStateOf(arrayOf<ProductsLine>()) }
    var prices by remember { mutableStateOf(arrayOf<Price>()) }
    var recipient by remember { mutableStateOf(arrayOf <ERPObject>())}
    var selectedRecipient by remember { mutableStateOf(ERPObject("", ""))}
    var offers by remember { mutableStateOf(arrayOf <ERPObject>())}
    var selectedOffers by remember { mutableStateOf(ERPObject("", ""))}
    var editRecipient by remember { mutableStateOf("")}
    var carrier by remember { mutableStateOf(arrayOf <ERPObject>())}
    var selectedCarrier by remember { mutableStateOf(ERPObject("", ""))}
    var editCarrier by remember { mutableStateOf("")}
    var unloadingAddress by remember { mutableStateOf(arrayOf <ERPObject>())}
    var selectedUnlAddress by remember { mutableStateOf(ERPObject("", ""))}
    var editUnlAddress by remember { mutableStateOf("")}
    var customersCars by remember { mutableStateOf(arrayOf<CarLine>()) }

    var carsNumbers by remember { mutableStateOf(arrayOf (""))}
    var drivers by remember { mutableStateOf(arrayOf (""))}
    var carBrands by remember { mutableStateOf(arrayOf (""))}

    if (!getDate) {
        getDate = true
        val client1 = HttpClient()
        CoroutineScope(Dispatchers.Main).launch {
            try {
                val response = withContext(Dispatchers.Default) {
                    client1.get("$urlConnect/ProductBalance?secret=$buyerCode") {
                        headers {
                            //append(HttpHeaders.Authorization, "Basic bW9kdWxzb2Z0OnRyeTY1NA==")
                        }
                    }
                }
                val responseString = response.bodyAsText()

                val responseArray = responseString.split("%")

                if (responseArray[0]!="")
                    responseArray[0].split("#").forEach {
                        if (it!="") {
                            val recipientDetal = it.split("|")
                            recipient += ERPObject(recipientDetal[0], recipientDetal[1].replace(regex, ""))
                        }
                    }
                if (responseArray[1]!="")
                    responseArray[1].split("#").forEach {
                        if (it!="") {
                            val carrierDetal = it.split("|")
                            carrier += ERPObject(carrierDetal[0], carrierDetal[1].replace(regex, ""))
                        }
                    }
                if (responseArray[2]!="")
                    responseArray[2].split("#").forEach {
                        if (it!="") {
                            val unloadingAddressDetal = it.split("|")
                            unloadingAddress += ERPObject(unloadingAddressDetal[0], unloadingAddressDetal[1].replace(regex, ""))
                        }
                    }

                if (responseArray[3]!="")
                    responseArray[3].split("#").forEach {
                        if (it!="") {

                            val customersCarsDetal = it.split("|")

                            customersCars += CarLine(
                                customersCarsDetal[0],
                                customersCarsDetal[1],
                                customersCarsDetal[2],
                                customersCarsDetal[3],
                                customersCarsDetal[4],
                                customersCarsDetal[5].toFloat(),
                                customersCarsDetal[6].toFloat(),
                                customersCarsDetal[7].toFloat()
                            )

                            if (carsNumbers.find { item -> item == customersCarsDetal[1] } == null)
                                carsNumbers += customersCarsDetal[1]
                            if (drivers.find { item -> item == customersCarsDetal[3] } == null)
                                drivers += customersCarsDetal[3]
                            if (carBrands.find { item -> item == customersCarsDetal[0] } == null)
                                carBrands += customersCarsDetal[0]
                        }
                    }

                if (responseArray[4]!="")
                    responseArray[4].split("#").forEach {
                        if (it!="") {
                            val productsDetal = it.split("|")
                            products += ProductsLine(
                                productsDetal[0],
                                productsDetal[1],
                                productsDetal[2].toInt()
                            )
                        }
                    }

                if (responseArray[5]!="")
                    responseArray[5].split("#").forEach {
                        if (it!="") {
                            val offersDetal = it.split("|")
                            offers += ERPObject(offersDetal[0], offersDetal[1])
                        }
                    }

                if (responseArray[6]!="")
                    responseArray[6].split("#").forEach {
                        if (it!="") {
                            val pricesDetal = it.split("|")
                            prices += Price(
                                pricesDetal[0],
                                pricesDetal[1],
                                pricesDetal[2].toInt()
                            )
                        }
                    }

            } catch (e: Exception) {
            }
        }
    }

    var cars by remember { mutableStateOf(arrayOf<CarLine>()) }
    var selectedProduct by remember { mutableStateOf(products[0]) }
    var driver by remember { mutableStateOf("") }
    var driverLicence by remember { mutableStateOf("") }
    var carBrand by remember { mutableStateOf("") }
    var carNumber by remember { mutableStateOf("") }
    var trailerNumber by remember { mutableStateOf("") }
    var carLength by remember { mutableStateOf("") }
    var carHeight by remember { mutableStateOf("") }
    var carWidth by remember { mutableStateOf("") }
    var date by remember { mutableStateOf("")} //"2023-08-02") }
    var quantity by remember { mutableStateOf(0) }
    var price by remember { mutableStateOf(0) }
    var sum by remember { mutableStateOf(0) }
    var comment by remember { mutableStateOf("") }

    if (breakpoint == Breakpoint.ZERO ||
        breakpoint == Breakpoint.SM ) {
        Column {
            //Date, sum, Payment, CAR INFO
            Column(modifier = GroupStyle.toModifier().padding(10.px).width(315.px)) {

                //Date
                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {
                    P(
                        attrs = Modifier
                            .width(50.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .align(Alignment.CenterVertically)
                            .color(Theme.Secondary.rgb)
                            .toAttrs()
                    ) {
                        Text(value = "Дата")
                    }

                    Input(type = InputType.Date,
                        attrs = InputStyle.toModifier()
                            .height(27.px)
                            .toAttrs {
                                onInput {
                                    date = it.value
                                }
                                value(date)
                            }
                    )
                }

                Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {

                    P(
                        attrs = Modifier
                            .width(50.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .align(Alignment.CenterVertically)
                            .color(Theme.Secondary.rgb)
                            .toAttrs()
                    ) {
                        Text(
                            value = "Умова"
                        )
                    }

                    Input(
                        type = InputType.Text,
                        attrs = InputStyle.toModifier().width(250.px).toAttrs {

                            id("offersInput$buyerCode")
                            name("offers$buyerCode")
                            list("offersList$buyerCode")

                            onInput {
                                selectedOffers =
                                    offers.find { offersItem -> offersItem.name == it.value } ?: ERPObject("", "")
                                price = prices.find { priceLine ->
                                    priceLine.guidOffers == selectedOffers.guid &&
                                            priceLine.guidProducts == selectedProduct.guid
                                }?.price
                                    ?: 0
                                sum = price * quantity
                            }
                        }
                    )

                    Datalist(attrs = InputStyle.toModifier().toAttrs {
                        id("offersList$buyerCode")
                    }) {
                        offers.forEach {
                            Option(value = it.name)
                        }
                    }
                }

                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {

                    P(
                        attrs = Modifier
                            .width(50.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .align(Alignment.CenterVertically)
                            .color(Theme.Secondary.rgb)
                            .toAttrs()
                    ) {
                        Text(value = "К-сть")
                    }

                    Input(type = InputType.Text,
                        attrs = InputStyle.toModifier()
                            .margin(right = 15.px)
                            .height(27.px)
                            .width(60.px)
                            .toAttrs {
                                onInput {
                                    val inputValue = it.value
                                    val numericValue = inputValue.toIntOrNull()
                                    if (numericValue != null) {
                                        quantity = numericValue
                                        sum = quantity * price
                                    } else {
                                    }
                                }
                                value(quantity)
                            }
                    )

                    P(
                        attrs = Modifier
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Theme.Secondary.rgb)
                            .align(Alignment.CenterVertically)
                            .toAttrs()
                    ) {
                        Text(value = "Сума: $sum грн.")
                    }
                }
            }

            //Отримувач, перевізник, місце розвантаження
            Column(
                modifier = GroupStyle.toModifier().padding(10.px).width(315.px)
            ) {

                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {
                    P(
                        attrs = Modifier
                            .fillMaxWidth()
                            .width(130.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Theme.Secondary.rgb)
                            .align(Alignment.CenterHorizontally)
                            .toAttrs()

                    ) {
                        Text(
                            value = "Отримувач"
                        )
                    }

                    Input(
                        type = InputType.Text,
                        attrs = InputStyle.toModifier().fillMaxWidth().toAttrs {

                            id("recipientInput$buyerCode")
                            name("recipient$buyerCode")
                            list("recipients$buyerCode")
                            onInput {
                                editRecipient = it.value.replace(regex, "")
                                selectedRecipient =
                                    recipient.find { recipientItem -> recipientItem.name == editRecipient } ?: ERPObject(
                                        "",
                                        editRecipient
                                    )
                            }
                            value(editRecipient)
                        }
                    )

                    Datalist(attrs = InputStyle.toModifier().toAttrs {
                        id("recipients$buyerCode")
                    }) {
                        recipient.forEach {
                            Option(value = it.name)
                        }
                    }
                }
                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {

                    P(
                        attrs = Modifier
                            .fillMaxWidth()
                            .width(130.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Theme.Secondary.rgb)
                            .align(Alignment.CenterHorizontally)
                            .toAttrs()
                    ) {
                        Text(
                            value = "Перевізник"
                        )
                    }

                    Input(
                        type = InputType.Text,
                        attrs = InputStyle.toModifier().fillMaxWidth().toAttrs {

                            id("carrierInput$buyerCode")
                            name("carrier$buyerCode")
                            list("carriers$buyerCode")
                            onInput {
                                editCarrier = it.value.replace(regex, "")
                                selectedCarrier =
                                    carrier.find { carrierItem -> carrierItem.name == editCarrier } ?: ERPObject(
                                        "",
                                        editCarrier
                                    )
                            }
                            value(editCarrier)
                        }
                    )

                    Datalist(attrs = InputStyle.toModifier().toAttrs {
                        id("carriers$buyerCode")
                    }) {
                        carrier.forEach {
                            Option(value = it.name)
                        }
                    }
                }

                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {

                    P(
                        attrs = Modifier
                            .fillMaxWidth()
                            .width(130.px)
                            .height(14.px)
                            .fontWeight(FontWeight.Bold)
                            .fontSize(14.px)
                            .color(Theme.Secondary.rgb)
                            .align(Alignment.CenterHorizontally)
                            .toAttrs()
                    ) {
                        Text(
                            value = "Адреса розв."
                        )
                    }

                    Input(
                        type = InputType.Text,
                        attrs = InputStyle.toModifier().fillMaxWidth().toAttrs {

                            id("unloadingAddressInput$buyerCode")
                            name("unloadingAddress$buyerCode")
                            list("unloadingAddressList$buyerCode")
                            onInput {
                                editUnlAddress = it.value.replace(regex, "")
                                selectedUnlAddress =
                                    unloadingAddress.find { adressItem -> adressItem.name == editUnlAddress } ?: ERPObject(
                                        "",
                                        editUnlAddress
                                    )
                            }
                            value(editUnlAddress)
                        }
                    )

                    Datalist(attrs = InputStyle.toModifier().toAttrs {
                        id("unloadingAddressList$buyerCode")
                    }) {
                        unloadingAddress.forEach {
                            Option(value = it.name)
                        }
                    }
                }
            }
        }
    }
    else {
        Row {
            //Date, sum, Payment, CAR INFO
            Column(modifier = GroupStyle.toModifier().padding(10.px).width(330.px)) {
                //Date
                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {
                    P(
                        attrs = Modifier
                            .width(50.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .align(Alignment.CenterVertically)
                            .color(Theme.Secondary.rgb)
                            .toAttrs()
                    ) {
                        Text(value = "Дата")
                    }

                    Input(type = InputType.Date,
                        attrs = InputStyle.toModifier()
                            .height(27.px)
                            .toAttrs {
                                onInput {
                                    date = it.value
                                }
                                value(date)
                            }
                    )
                }

                Row(modifier = Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {

                    P(
                        attrs = Modifier
                            .width(50.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .align(Alignment.CenterVertically)
                            .color(Theme.Secondary.rgb)
                            .toAttrs()
                    ) {
                        Text(
                            value = "Умова"
                        )
                    }

                    Input(
                        type = InputType.Text,
                        attrs = InputStyle.toModifier().width(250.px).toAttrs {

                            id("offersInput$buyerCode")
                            name("offers$buyerCode")
                            list("offersList$buyerCode")

                            onInput {
                                selectedOffers =
                                    offers.find { offersItem -> offersItem.name == it.value } ?: ERPObject("", "")
                                price = prices.find { priceLine ->
                                    priceLine.guidOffers == selectedOffers.guid &&
                                            priceLine.guidProducts == selectedProduct.guid
                                }?.price
                                    ?: 0
                                sum = price * quantity
                            }
                        }
                    )

                    Datalist(attrs = InputStyle.toModifier().toAttrs {
                        id("offersList$buyerCode")
                    }) {
                        offers.forEach {
                            Option(value = it.name)
                        }
                    }
                }

                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {

                    P(
                        attrs = Modifier
                            .width(50.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .align(Alignment.CenterVertically)
                            .color(Theme.Secondary.rgb)
                            .toAttrs()
                    ) {
                        Text(value = "К-сть")
                    }

                    Input(type = InputType.Text,
                        attrs = InputStyle.toModifier()
                            .margin(right = 15.px)
                            .height(27.px)
                            .width(60.px)
                            .toAttrs {
                                onInput {
                                    val inputValue = it.value
                                    val numericValue = inputValue.toIntOrNull()
                                    if (numericValue != null) {
                                        quantity = numericValue
                                        sum = quantity * price
                                    } else {
                                    }
                                }
                                value(quantity)
                            }
                    )

                    P(
                        attrs = Modifier
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Theme.Secondary.rgb)
                            .align(Alignment.CenterVertically)
                            .toAttrs()
                    ) {
                        Text(value = "Сума: $sum грн.")
                    }
                }
            }

            //Отримувач, перевізник, місце розвантаження
            Column(
                modifier = GroupStyle.toModifier().padding(10.px).width(330.px)
            ) {

                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {
                    P(
                        attrs = Modifier
                            .fillMaxWidth()
                            .width(130.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Theme.Secondary.rgb)
                            .align(Alignment.CenterHorizontally)
                            .toAttrs()

                    ) {
                        Text(
                            value = "Отримувач"
                        )
                    }

                    Input(
                        type = InputType.Text,
                        attrs = InputStyle.toModifier().fillMaxWidth().toAttrs {

                            id("recipientInput$buyerCode")
                            name("recipient$buyerCode")
                            list("recipients$buyerCode")
                            pattern("[A-Za-zА-Яа-я0-9.,`'-]+")
                            onInput {
                                editRecipient = it.value.replace(regex, "")
                                selectedRecipient =
                                    recipient.find { recipientItem -> recipientItem.name == editRecipient } ?: ERPObject(
                                        "",
                                        editRecipient
                                    )
                            }
                            value(editRecipient)
                        }
                    )

                    Datalist(attrs = InputStyle.toModifier().toAttrs {
                        id("recipients$buyerCode")
                    }) {
                        recipient.forEach {
                            Option(value = it.name)
                        }
                    }
                }
                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {

                    P(
                        attrs = Modifier
                            .fillMaxWidth()
                            .width(130.px)
                            .height(14.px)
                            .fontSize(14.px)
                            .fontWeight(FontWeight.Bold)
                            .color(Theme.Secondary.rgb)
                            .align(Alignment.CenterHorizontally)
                            .toAttrs()
                    ) {
                        Text(
                            value = "Перевізник"
                        )
                    }

                    Input(
                        type = InputType.Text,
                        attrs = InputStyle.toModifier().fillMaxWidth().toAttrs {

                            id("carrierInput$buyerCode")
                            name("carrier$buyerCode")
                            list("carriers$buyerCode")
                            onInput {
                                editCarrier = it.value.replace(regex, "")
                                selectedCarrier =
                                    carrier.find { carrierItem -> carrierItem.name == editCarrier } ?: ERPObject(
                                        "",
                                        editCarrier
                                    )
                            }
                            value(editCarrier)
                        }
                    )

                    Datalist(attrs = InputStyle.toModifier().toAttrs {
                        id("carriers$buyerCode")
                    }) {
                        carrier.forEach {
                            Option(value = it.name)
                        }
                    }
                }

                Row(modifier = Modifier, verticalAlignment = Alignment.CenterVertically) {

                    P(
                        attrs = Modifier
                            .fillMaxWidth()
                            .width(130.px)
                            .height(14.px)
                            .fontWeight(FontWeight.Bold)
                            .fontSize(14.px)
                            .color(Theme.Secondary.rgb)
                            .align(Alignment.CenterHorizontally)
                            .toAttrs()
                    ) {
                        Text(
                            value = "Адреса розв."
                        )
                    }

                    Input(
                        type = InputType.Text,
                        attrs = InputStyle.toModifier().fillMaxWidth().toAttrs {

                            id("unloadingAddressInput$buyerCode")
                            name("unloadingAddress$buyerCode")
                            list("unloadingAddressList$buyerCode")
                            pattern("[A-Za-zА-Яа-я0-9.,`'-]+")
                            onInput {
                                editUnlAddress = it.value.replace(regex, "")
                                selectedUnlAddress =
                                    unloadingAddress.find { adressItem -> adressItem.name == editUnlAddress } ?: ERPObject(
                                        "",
                                        editUnlAddress
                                    )
                            }
                            value(editUnlAddress)
                        }
                    )

                    Datalist(attrs = InputStyle.toModifier().toAttrs {
                        id("unloadingAddressList$buyerCode")
                    }) {
                        unloadingAddress.forEach {
                            Option(value = it.name)
                        }
                    }
                }
            }
        }
    }

    //Products
    Column(modifier = GroupStyle.toModifier()) {

        var indexProd = 0
        val countProd = products.count()
        val countCol = when (breakpoint) {
            Breakpoint.ZERO -> 1
            Breakpoint.SM -> 1
            Breakpoint.MD -> 2
            Breakpoint.LG -> 3
            Breakpoint.XL -> 4
            else -> 5
        }

        while (indexProd < countProd) {

            Row(modifier = Modifier.padding(left = 5.px, right = 5.px)) {

                for (i in indexProd..indexProd + countCol-1) {
                    if (i < countProd) {
                        Row {
                            Button(
                                modifier = MainButtonStyle.toModifier()
                                    .margin(top = 5.px)
                                    .fontSize(12.px)
                                    .height(40.px)
                                    .backgroundColor(
                                        if (products[i] == selectedProduct)
                                            Theme.Secondary.rgb
                                        else Theme.Primary.rgb
                                    )
                                    .width(240.px),

                                onClick = {

                                    selectedProduct = products[i]

                                    price = prices.find { priceLine -> priceLine.guidOffers == selectedOffers.guid &&
                                            priceLine.guidProducts == selectedProduct.guid}?.price
                                        ?:0

                                    sum = price * quantity
                                }
                            ) { Text(products[i].name) }

                            Column(
                                modifier = Modifier
                                    .fontSize(12.px)
                                    .height(45.px)
                                    .width(55.px)
                                    .fontWeight(FontWeight.Bold)
                            ) {
                                P(
                                    attrs = Modifier
                                        .margin(left = 5.px, top = 5.px)
                                        .padding(top = 5.px)
                                        .height(20.px)
                                        .width(55.px)
                                        .color(Theme.DarkBlue.rgb)
                                        .toAttrs()
                                ) {
                                    Text(value = products[i].balance.toString() + " т.")
                                }
                                P(
                                    attrs = Modifier
                                        .margin(left = 5.px, top = 5.px)
                                        .padding(top = 0.px)
                                        .height(20.px)
                                        .width(55.px)
                                        .color(Theme.Secondary.rgb)
                                        .toAttrs()
                                ) {
                                    Text(
                                        value = (prices.find { priceLine -> (priceLine.guidOffers == selectedOffers.guid)
                                                && (priceLine.guidProducts == products[i].guid) }?.price
                                            ?:0).toString() + "грн"
                                    )
                                }
                            }
                        }
                    }
                }
                indexProd += countCol
            }

        }
    }

    Datalist(attrs = InputStyle.toModifier().toAttrs {
        id("carsNumbers$buyerCode")
    }) {
        carsNumbers.forEach {
            Option(value = it)
        }
    }
    Datalist(attrs = InputStyle.toModifier().toAttrs {
        id("drivers$buyerCode")
    }) {
        drivers.forEach {
            Option(value = it)
        }
    }
    Datalist(attrs = InputStyle.toModifier().toAttrs {
        id("carBrands$buyerCode")
    }) {
        carBrands.forEach {
            Option(value = it)
        }
    }

    //CARS
    if (breakpoint == Breakpoint.ZERO || breakpoint == Breakpoint.SM || breakpoint == Breakpoint.MD) {
        Column(modifier = GroupStyle.toModifier().width(315.px).padding(10.px)) {

        Input(type = InputType.Text,

                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .fontSize(12.px)
                    .fillMaxWidth()
                    .toAttrs {
                        placeholder("№ машини")
                        list("carsNumbers$buyerCode")
                        onInput {
                            carNumber = standardizeNumber(it.value)

                            if (carNumber.length >= 5 || carLength.isEmpty()) {

                                customersCars.forEach { carLine ->
                                    if (carLine.number == carNumber) {
                                        carBrand = carLine.brand
                                        trailerNumber = carLine.trailerNumber
                                        driver = carLine.driver
                                        driverLicence = carLine.driverLicence
                                        carLength = carLine.carLength.toString()
                                        carHeight = carLine.carHeight.toString()
                                        carWidth = carLine.carWidth.toString()
                                    }
                                }
                            }

                        }
                        value(carNumber)
                    }
            )

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .fontSize(12.px)
                    .fillMaxWidth()
                    .toAttrs {
                        placeholder("Марка")
                        list("carBrands$buyerCode")
                        onInput {
                            carBrand = it.value
                        }
                        value(carBrand)
                    }
            )

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .fontSize(12.px)
                    .fillMaxWidth()
                    .toAttrs {
                        placeholder("Водій")
                        list("drivers$buyerCode")
                        onInput {
                            driver = it.value
                        }
                        value(driver)
                    }
            )

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .fontSize(12.px)
                    .fillMaxWidth()
                    .toAttrs {
                        placeholder("№ Посвідчення")
                        onInput {
                            driverLicence = it.value
                        }
                        value(driverLicence)
                    }
            )

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .fillMaxWidth()
                    .fontSize(12.px)
                    .toAttrs {
                        placeholder("Довжина")
                        onInput {
                            val inputValue = it.value.replace(",", ".")
                            val numericValue = inputValue.toDoubleOrNull()
                            if (numericValue != null) {
                                carLength = inputValue
                            }
                        }
                        value(carLength)
                    }
            )

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .fillMaxWidth()
                    .fontSize(12.px)
                    .toAttrs {
                        placeholder("Ширина")
                        onInput {
                            val inputValue = it.value.replace(",", ".")
                            val numericValue = inputValue.toDoubleOrNull()
                            if (numericValue != null) {
                                carWidth = inputValue
                            }
                        }
                        value(carWidth)
                    }
            )

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .fillMaxWidth()
                    .fontSize(12.px)
                    .toAttrs {
                        placeholder("Висота")
                        onInput {
                            val inputValue = it.value.replace(",", ".")
                            val numericValue = inputValue.toDoubleOrNull()
                            if (numericValue != null) {
                                carHeight = inputValue
                            }
                        }
                        value(carHeight)
                    }
            )

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .fontSize(12.px)
                    .fillMaxWidth()
                    .toAttrs {
                        placeholder("№ причепа")
                        onInput {
                            trailerNumber = it.value
                        }
                        value(trailerNumber)
                    }
            )

            Button(
                modifier = MainButtonStyle.toModifier()
                    .height(35.px)
                    .fillMaxWidth()
                    .backgroundColor(Theme.Primary.rgb)
                    .fontSize(12.px)
                    .margin(topBottom = 5.px),
                onClick = {
                    cars += CarLine(
                        carBrand,
                        carNumber,
                        trailerNumber,
                        driver,
                        driverLicence,
                        if (carLength == "") 0F else carLength.toFloat(),
                        if (carHeight == "") 0F else carHeight.toFloat(),
                        if (carWidth == "") 0F else carWidth.toFloat()
                    )
                    carNumber = ""
                    trailerNumber = ""
                    driver = ""
                    driverLicence = ""
                    carBrand = ""
                    carLength = ""
                    carHeight = ""
                    carWidth = ""

                }
            ) {
                Text("+")
            }

            cars.forEach { item ->
                Column(modifier = GroupStyle.toModifier().fillMaxWidth()) {
                    P(attrs = Modifier.margin(0.px).padding(0.px).toAttrs()) {
                        Text(item.number + " " + item.brand + " " + item.trailerNumber)
                    }
                    P(attrs = Modifier.margin(0.px).padding(0.px).toAttrs())  {
                        Text(item.driver + " " + item.driverLicence)
                    }
                    P(attrs = Modifier.margin(0.px).padding(0.px).toAttrs())  {
                        Text(item.carLength.toString() + " | " + item.carWidth.toString() + " | " + item.carHeight.toString())
                    }
                }
            }

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .margin(top = 10.px)
                    .fillMaxSize()
                    .fontSize(12.px)
                    .toAttrs {
                        placeholder("Коментар")
                        onInput {
                            comment = it.value.replace(regex, "")
                        }
                        value(comment)
                    }
            )
        }
    }
    else {
        Column(modifier = GroupStyle.toModifier().width(920.px).padding(10.px)) {

            Row() {

                Input(type = InputType.Text,
                    attrs = InputStyle.toModifier()
                        .padding(5.px)
                        .margin(top = 5.px)
                        .fontSize(12.px)
                        .width(100.px)
                        .toAttrs {
                            placeholder("№ машини")
                            list("carsNumbers$buyerCode")
                            onInput {
                                carNumber = standardizeNumber(it.value)

                                if (carNumber.length >= 5 || carLength.isEmpty()) {

                                    customersCars.forEach { carLine ->
                                        if (carLine.number == carNumber) {
                                            carBrand = carLine.brand
                                            trailerNumber = carLine.trailerNumber
                                            driver = carLine.driver
                                            driverLicence = carLine.driverLicence
                                            carLength = carLine.carLength.toString()
                                            carHeight = carLine.carHeight.toString()
                                            carWidth = carLine.carWidth.toString()
                                        }
                                    }
                                }

                            }
                            value(carNumber)
                        }
                )

                Input(type = InputType.Text,
                    attrs = InputStyle.toModifier()
                        .padding(5.px)
                        .margin(top = 5.px, left = 5.px)
                        .fontSize(12.px)
                        .width(100.px)
                        .toAttrs {
                            placeholder("Марка")
                            list("carBrands$buyerCode")
                            onInput {
                                carBrand = it.value
                            }
                            value(carBrand)
                        }
                )

                Input(type = InputType.Text,
                    attrs = InputStyle.toModifier()
                        .padding(5.px)
                        .margin(top = 5.px, left = 5.px)
                        .fontSize(12.px)
                        .width(200.px)
                        .toAttrs {
                            placeholder("Водій")
                            list("drivers$buyerCode")
                            onInput {
                                driver = it.value
                            }
                            value(driver)
                        }
                )

                Input(type = InputType.Text,
                    attrs = InputStyle.toModifier()
                        .padding(5.px)
                        .margin(top = 5.px, left = 5.px)
                        .fontSize(12.px)
                        .width(100.px)
                        .toAttrs {
                            placeholder("№ Посвідчення")
                            onInput {
                                driverLicence = it.value
                            }
                            value(driverLicence)
                        }
                )

                Input(type = InputType.Text,
                    attrs = InputStyle.toModifier()
                        .padding(5.px)
                        .margin(top = 5.px, left = 5.px)
                        .width(70.px)
                        .fontSize(12.px)
                        .toAttrs {
                            placeholder("Довжина")
                            onInput {
                                val inputValue = it.value.replace(",", ".")
                                val numericValue = inputValue.toDoubleOrNull()
                                if (numericValue != null) {
                                    carLength = inputValue
                                }
                            }
                            value(carLength)
                        }
                )

                Input(type = InputType.Text,
                    attrs = InputStyle.toModifier()
                        .padding(5.px)
                        .margin(top = 5.px, left = 5.px)
                        .width(70.px)
                        .fontSize(12.px)
                        .toAttrs {
                            placeholder("Ширина")
                            onInput {
                                val inputValue = it.value.replace(",", ".")
                                val numericValue = inputValue.toDoubleOrNull()
                                if (numericValue != null) {
                                    carWidth = inputValue
                                }
                            }
                            value(carWidth)
                        }
                )

                Input(type = InputType.Text,
                    attrs = InputStyle.toModifier()
                        .padding(5.px)
                        .margin(top = 5.px, left = 5.px)
                        .width(70.px)
                        .fontSize(12.px)
                        .toAttrs {
                            placeholder("Висота")
                            onInput {
                                val inputValue = it.value.replace(",", ".")
                                val numericValue = inputValue.toDoubleOrNull()
                                if (numericValue != null) {
                                    carHeight = inputValue
                                }
                            }
                            value(carHeight)
                        }
                )

                Input(type = InputType.Text,
                    attrs = InputStyle.toModifier()
                        .padding(5.px)
                        .margin(top = 5.px, left = 5.px)
                        .fontSize(12.px)
                        .width(100.px)
                        .toAttrs {
                            placeholder("№ причепа")
                            onInput {
                                trailerNumber = it.value
                            }
                            value(trailerNumber)
                        }
                )

                Button(
                    modifier = MainButtonStyle.toModifier()
                        .height(27.px)
                        .width(50.px)
                        .margin(left = 5.px, top = 5.px)
                        .backgroundColor(Theme.Primary.rgb)
                        .fontSize(12.px)
                        .padding(0.px),
                    onClick = {
                        cars += CarLine(
                            carBrand,
                            carNumber,
                            trailerNumber,
                            driver,
                            driverLicence,
                            if (carLength == "") 0F else carLength.toFloat(),
                            if (carHeight == "") 0F else carHeight.toFloat(),
                            if (carWidth == "") 0F else carWidth.toFloat()
                        )
                        carNumber = ""
                        trailerNumber = ""
                        driver = ""
                        driverLicence = ""
                        carBrand = ""
                        carLength = ""
                        carHeight = ""
                        carWidth = ""

                    }
                ) { Text("+") }
            }

            cars.forEach { item ->
                Column(modifier = Modifier.width(200.px)) {
                    Row() {
                        Input(type = InputType.Text,
                            attrs = Modifier
                                .padding(5.px)
                                .margin(top = 5.px)
                                .fontSize(12.px)
                                .width(100.px)
                                .toAttrs {
                                    value(item.number)
                                }
                        )
                        Input(type = InputType.Text,
                            attrs = Modifier
                                .padding(5.px)
                                .margin(top = 5.px, left = 5.px)
                                .fontSize(12.px)
                                .width(100.px)
                                .toAttrs {
                                    value(item.brand)
                                }
                        )
                        Input(type = InputType.Text,
                            attrs = Modifier
                                .padding(5.px)
                                .margin(top = 5.px, left = 5.px)
                                .fontSize(12.px)
                                .width(200.px)
                                .toAttrs {
                                    value(item.driver)
                                }
                        )
                        Input(type = InputType.Text,
                            attrs = Modifier
                                .padding(5.px)
                                .margin(top = 5.px, left = 5.px)
                                .fontSize(12.px)
                                .width(100.px)
                                .toAttrs {
                                    value(item.driverLicence)
                                }
                        )
                        Input(type = InputType.Text,
                            attrs = Modifier
                                .padding(5.px)
                                .margin(top = 5.px, left = 5.px)
                                .width(70.px)
                                .fontSize(12.px)
                                .toAttrs {
                                    value(item.carLength)
                                }
                        )
                        Input(type = InputType.Text,
                            attrs = Modifier
                                .padding(5.px)
                                .margin(top = 5.px, left = 5.px)
                                .width(70.px)
                                .fontSize(12.px)
                                .toAttrs {
                                    value(item.carWidth)
                                }
                        )
                        Input(type = InputType.Text,
                            attrs = Modifier
                                .padding(5.px)
                                .margin(top = 5.px, left = 5.px)
                                .width(70.px)
                                .fontSize(12.px)
                                .toAttrs {
                                    value(item.carHeight)
                                }
                        )
                        Input(type = InputType.Text,
                            attrs = Modifier
                                .padding(5.px)
                                .margin(top = 5.px, left = 5.px)
                                .fontSize(12.px)
                                .width(100.px)
                                .toAttrs {
                                    value(item.trailerNumber)
                                }
                        )
                    }
                }
            }

            Input(type = InputType.Text,
                attrs = InputStyle.toModifier()
                    .padding(5.px)
                    .margin(top = 10.px)
                    .fillMaxSize()
                    .fontSize(12.px)
                    .toAttrs {
                        placeholder("Коментар")
                        onInput {
                            comment = it.value.replace(regex, "")
                        }
                        value(comment)
                    }
            )
        }
    }

    var responseText by remember { mutableStateOf("") }

    Column(modifier = Modifier
        .fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally) {
        Button(
            modifier = MainButtonStyle.toModifier()
                .width(200.px)
                .backgroundColor(Theme.Primary.rgb)
                .margin(topBottom = 5.px),
            onClick = {

                val client = HttpClient()

                CoroutineScope(Dispatchers.Main).launch {
                    try {
                        if (carNumber!="") {
                            cars += CarLine(
                                carBrand,
                                carNumber,
                                trailerNumber,
                                driver,
                                driverLicence,
                                if (carLength == "") 0F else carLength.toFloat(),
                                if (carHeight == "") 0F else carHeight.toFloat(),
                                if (carWidth == "") 0F else carWidth.toFloat()
                            )
                            carNumber = ""
                            trailerNumber = ""
                            driver = ""
                            driverLicence = ""
                            carBrand = ""
                            carLength = ""
                            carHeight = ""
                            carWidth = ""
                        }

                        val response = withContext(Dispatchers.Default) {
                            client.post("$urlConnect/PlanLoading")
                            {
                                headers {
                                    append(HttpHeaders.Accept, "application/json")
                                }

                                var bodycontent = "{ "
                                bodycontent += "\"date\": \"$date\","
                                bodycontent += "\"buyer\": \"$buyerCode\","
                                bodycontent += "\"recipient\" : \"${selectedRecipient.name.replace(regex, "")}\","
                                bodycontent += "\"recipientGuid\" : \"${selectedRecipient.guid}\","
                                bodycontent += "\"carrier\" : \"${selectedCarrier.name.replace(regex, "")}\","
                                bodycontent += "\"carrierGuid\" : \"${selectedCarrier.guid}\","
                                bodycontent += "\"unlAddress\" : \"${selectedUnlAddress.name.replace(regex, "")}\","
                                bodycontent += "\"unlAddressGuid\" : \"${selectedUnlAddress.guid}\","
                                bodycontent += "\"offersGuid\" : \"${selectedOffers.guid}\","
                                bodycontent += "\"productGuid\": \"${selectedProduct.guid}\","
                                bodycontent += "\"quantity\": $quantity,"
                                bodycontent += "\"price\": $price,"
                                bodycontent += "\"sum\": $sum,"
                                bodycontent += "\"comment\": \"${comment.replace(regex, "")}\","

                                bodycontent += "\"cars\": ["

                                cars.forEach { carInfo ->
                                    bodycontent += "{" +
                                            "\"carBrand\": \"${carInfo.brand.replace(regex, "")}\"," +
                                            "\"carNumber\": \"${carInfo.number.replace(regex, "")}\"," +
                                            "\"trailerNumber\": \"${carInfo.trailerNumber.replace(regex, "")}\"," +
                                            "\"driver\": \"${carInfo.driver.replace(regex, "")}\"," +
                                            "\"driverLicence\": \"${carInfo.driverLicence.replace(regex, "")}\"," +
                                            "\"carLength\": ${carInfo.carLength}," +
                                            "\"carHeight\": ${carInfo.carHeight}," +
                                            "\"carWidth\": ${carInfo.carWidth} },"
                                }

                                bodycontent =
                                    if (cars.isNotEmpty()) bodycontent.substring(
                                        0,
                                        bodycontent.length - 1
                                    ) + "]}" else bodycontent + "]}"

                                setBody(bodycontent)
                            }
                        }

                        if (response.status.value == 200) {

                            selectedProduct = ProductsLine("","", 0)
                            cars = arrayOf<CarLine>()
                            carNumber = ""
                            trailerNumber = ""
                            driver = ""
                            driverLicence = ""
                            quantity = 0
                            price = 0
                            sum = 0
                            carLength = ""
                            carHeight = ""
                            carWidth = ""
                            comment = ""
//                            selectedCarrier = ERPObject("", "")
//                            selectedRecipient = ERPObject("", "")
//                            selectedOffers = ERPObject("", "")
//                            selectedUnlAddress = ERPObject("", "")

                            responseText = "Заявку успішно створено"
                            delay(10000)
                            responseText = ""
                        }
                        else
                        {
                            responseText = "Помилка при створені заявки"
                            delay(10000)
                            responseText = ""
                        }

                    } catch (e: Exception) {
                        responseText = "Помилка при створені заявки"
                        delay(10000)
                        responseText = ""
                    }
                }
            }
        ) {
            if (responseText=="") Text("Відправити") else Text(responseText)}
    }
}

fun standardizeNumber(number: String) : String {

    var stNumber = number.uppercase()

    stNumber.replace(" ", "")
    stNumber.replace("-", "")

    stNumber.replace("А", "A")
    stNumber.replace("В", "B")
    stNumber.replace("Е", "E")
    stNumber.replace("І", "I")
    stNumber.replace("К", "K")
    stNumber.replace("М", "M")
    stNumber.replace("Н", "H")
    stNumber.replace("О", "O")
    stNumber.replace("Р", "P")
    stNumber.replace("С", "C")
    stNumber.replace("Т", "T")
    stNumber.replace("Х", "X")

    return stNumber

}

class CarLine(
    val brand : String,
    val number : String,
    val trailerNumber : String,
    val driver: String,
    val driverLicence: String,
    val carLength: Float,
    val carHeight: Float,
    val carWidth: Float
)

data class ProductsLine(
    var guid : String,
    var name: String,
    var balance: Int
)

data class ERPObject(
    var guid : String,
    var name: String
)

data class Price(
    var guidOffers : String,
    var guidProducts : String,
    var price: Int
)